/**
 * Scroll Hint Component
 * 
 * Shows a subtle "Scroll Down" indicator in the bottom-right corner if the user
 * remains idle on the home screen for 10 seconds. Shows twice with a 5-second gap.
 * Dismisses immediately if the user scrolls or clicks the indicator.
 */

export function mountScrollHint(root) {
	const hint = (root && root.querySelector("#solufy-scroll-hint")) || document.querySelector("#solufy-scroll-hint");
	if (!hint) return;

	let hasScrolled = false;
	let timer1 = null;
	let timer1Hide = null;
	let timer2 = null;
	let timer2Hide = null;

	const hideIndicator = () => {
		hint.classList.remove("is-visible");
	};

	const showIndicator = () => {
		if (hasScrolled) return;
		hint.classList.add("is-visible");
	};

	const clearAllTimers = () => {
		if (timer1) clearTimeout(timer1);
		if (timer1Hide) clearTimeout(timer1Hide);
		if (timer2) clearTimeout(timer2);
		if (timer2Hide) clearTimeout(timer2Hide);
		timer1 = null;
		timer1Hide = null;
		timer2 = null;
		timer2Hide = null;
	};

	const onScroll = () => {
		if (window.scrollY > 80) {
			hasScrolled = true;
			hideIndicator();
			clearAllTimers();
			window.removeEventListener("scroll", onScroll);
		}
	};

	const onClick = (e) => {
		e.preventDefault();
		hasScrolled = true;
		hideIndicator();
		clearAllTimers();

		const target = document.querySelector("#services") || document.querySelector(".solufy-services");
		if (target) {
			target.scrollIntoView({ behavior: "smooth" });
		} else {
			window.scrollBy({ top: window.innerHeight * 0.85, behavior: "smooth" });
		}
	};

	// If page is already scrolled down, do not start idle prompt
	if (window.scrollY > 80) {
		return;
	}

	window.addEventListener("scroll", onScroll, { passive: true });
	hint.addEventListener("click", onClick);

	// Start 10-second idle countdown
	timer1 = setTimeout(() => {
		if (hasScrolled) return;
		showIndicator();

		// Keep visible for 3.5 seconds
		timer1Hide = setTimeout(() => {
			hideIndicator();

			// 5-second gap before showing the 2nd time
			timer2 = setTimeout(() => {
				if (hasScrolled) return;
				showIndicator();

				// Keep visible for 3.5 seconds
				timer2Hide = setTimeout(() => {
					hideIndicator();
				}, 3500);
			}, 5000);
		}, 3500);
	}, 10000);

	return () => {
		window.removeEventListener("scroll", onScroll);
		hint.removeEventListener("click", onClick);
		clearAllTimers();
		hideIndicator();
	};
}
